import React from 'react';
import Card from '../../../components/ACS-Dashboard/ACS-Blocks/Card';
import ScrollableContainer from '../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer';

const DocumentUploaderList = ({ isCollapsed }) => {
  const cardsData = [
    { title: "Processed BOLs", percentage: "+12%", percentageColor: "text-green-500", comparisonText: "vs last week", mainValue: "34", buttonText: "View" },
    { title: "New BOLs", percentage: "-8%", percentageColor: "text-red-500", comparisonText: "vs yesterday", mainValue: "27", buttonText: "Track" },
    { title: "Approved BOLs", percentage: "+5%", percentageColor: "text-green-500", comparisonText: "vs last month", mainValue: "45", buttonText: "Review" },
    { title: "Pending BOLs", percentage: "+3%", percentageColor: "text-green-500", comparisonText: "vs last month", mainValue: "41", buttonText: "Check" },
    { title: "Rejected BOLs", percentage: "-2%", percentageColor: "text-red-500", comparisonText: "vs last month", mainValue: "39", buttonText: "Resolve" },
    { title: "Completed BOLs", percentage: "+7%", percentageColor: "text-green-500", comparisonText: "vs last month", mainValue: "48", buttonText: "View" },
    { title: "Flagged BOLs", percentage: "+1%", percentageColor: "text-green-500", comparisonText: "vs last month", mainValue: "44", buttonText: "Review" },
    { title: "Archived BOLs", percentage: "-4%", percentageColor: "text-red-500", comparisonText: "vs last month", mainValue: "38", buttonText: "View" }
  ]
  
  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
      <ScrollableContainer direction="x" className="scrollbar-none">
        <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]"> {/* Container-queried gap */}
          {cardsData.map((card, index) => (
            <div 
              key={index} 
              className="scroll-snap-align-start"
              style={{ 
                minWidth: 'clamp(12rem,30cqw,11rem)',  // 30% of container width
                flex: '0 0 auto'  // Prevent flex growing
              }}
            >
              <Card 
                {...card}
                className="p-fluid-1.5"
                titleClassName="text-fluid-lg"
                valueClassName="text-fluid-xl"
                metaClassName="text-fluid-sm"
              />
            </div>
          ))}
        </div>
      </ScrollableContainer>
    </div>
  );
};

export default DocumentUploaderList;
